import { http } from './http';

function apiErr(err) {
  const msg = err?.response?.data?.error || err?.message || 'Request failed';
  const next = new Error(msg);
  return Promise.reject(next);
}

export function login(payload) {
  const { identifier, email, password } = payload || {};
  return http
    .post('/api/v1/auth/login', {
      identifier: identifier ?? email,
      password,
    })
    .then((r) => r.data)
    .catch(apiErr);
}

export function register(payload) {
  return http.post('/api/v1/auth/register', payload).then((r) => r.data).catch(apiErr);
}

export function forgotPassword(payload) {
  return http.post('/api/v1/auth/forgot-password', payload).then((r) => r.data);
}

export function resetPassword(payload) {
  return http.post('/api/v1/auth/reset-password', payload).then((r) => r.data);
}

export function getMe() {
  return http.get('/api/v1/auth/me').then((r) => r.data);
}

export function updateMe(payload) {
  return http.patch('/api/v1/auth/me', payload).then((r) => r.data);
}

export function changeMyPassword(payload) {
  return http.patch('/api/v1/auth/me/password', payload).then((r) => r.data);
}
